import React, { FC, useCallback } from "react";
import { sendOfflineMsg } from "../../store/actions";
import { useChatServerDispatch } from "../../utils/useChatServerDispatch";
import { MessageFormData } from "../MessageForm";
import OfflineForm from "./OfflineForm";

export interface OfflineFormContainerProps {
    readonly time?: string;
}

const OfflineFormContainer: FC<OfflineFormContainerProps> = props => {

    const dispatch = useChatServerDispatch();

    const handleSubmit = useCallback((data: MessageFormData) => {
        dispatch(sendOfflineMsg(data));
    }, [dispatch]);

    return (
        <>
            <span className="message-sr-only">{"at " + props.time + " system message"}</span>
            <OfflineForm
                onSubmit={handleSubmit}
            />
        </>
    );
};

export default OfflineFormContainer;